import { render, staticRenderFns } from "./teams-list.vue?vue&type=template&id=bc39c276&scoped=true&"
import script from "./teams-list.vue?vue&type=script&lang=js&"
export * from "./teams-list.vue?vue&type=script&lang=js&"
import style0 from "./teams-list.vue?vue&type=style&index=0&id=bc39c276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc39c276",
  null
  
)

component.options.__file = "teams-list.vue"
export default component.exports